module.exports = __webpack_public_path__ + "7abaed8570d5e1145a9e5e7d691b2f33.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/labels/products/plant.jpg
 ** module id = 444
 ** module chunks = 0
 **/